Vendd.Scripts.load(function () {
    var $wrapper = $('.brand-list');

    if ($wrapper.hasClass("js-lazyload") && typeof $.fn.lazyload === "function" && $wrapper.length > 0) {
        $("img[data-lazyload]", $wrapper).lazyload({
            effect: 'fadeIn',
            threshold: 500,
            skip_invisible: false
        }).removeAttr("data-lazyload");
    };
});

